import { AddOutline24Icon } from "@vygruppen/spor-icon-react";
import { EventInteractionBar } from "features/CenterContent/RoleContent/EventInteraction/EventInteractionBar";
import { EventsOverviewButtonAndModal } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/EventsOverviewButtonAndModal";
import { InternalMessageOverviewButtonAndModal } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/InternalMessageOverviewButtonAndModal";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroup, Button } from "shared/components/Spor";
import { useEventMode, useStretchBuilder } from "stores/useStretchBuilder";
import { useTheme } from "styled-components";

export const CreateEvent: FC = () => {
  const [eventMode, setEventMode] = useEventMode((state) => [
    state.eventMode,
    state.setEventMode,
  ]);
  const setStretchBuilderModalState = useStretchBuilder(
    (state) => state.setStretchBuilderModalState,
  );
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        pointerEvents: "none",
      }}
    >
      {!eventMode ? (
        <ButtonGroup position="relative" top="12px" left={2}>
          <Button
            _active={{ backgroundColor: theme.colorBackgroundSecondary }}
            leftIcon={<AddOutline24Icon />}
            pointerEvents="auto"
            onClick={() => {
              setEventMode(true);
              setStretchBuilderModalState({
                type: "infrastructure",
                stretchBuilderMode: true,
              });
            }}
          >
            {t("Ny hendelse")}
          </Button>
          <EventsOverviewButtonAndModal />
          <InternalMessageOverviewButtonAndModal />
        </ButtonGroup>
      ) : (
        <EventInteractionBar />
      )}
    </div>
  );
};
